export const formatCardExpire = ({ cardExpireMonth, cardExpireYear }: { cardExpireMonth: string; cardExpireYear: string }) => {
  return `${cardExpireMonth.padStart(2, '0')}/${cardExpireYear.padStart(2, '0')}`
}
